module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-end"><div class="answer-end"><p class="body">需要把4个题答完再交卷哦~</p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/answer.end.html
// module id = 33
// module chunks = 0